import { render, staticRenderFns } from "./sosType.vue?vue&type=template&id=1421137c"
import script from "./sosType.vue?vue&type=script&lang=js"
export * from "./sosType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports